import { ajaxCall } from "@/shared/connection/ajax-call";
import { makeLogger } from "@/shared/consola";
import { handleErrorByMessage } from "@/shared/connection/with-store-error-handlers";

const logger = makeLogger("page-tools.service");

const PAGE_ENDPOINT = `/pages`;

export const pageToolsService = {
    getAllUserToolProjects() {
        logger.trace("getAllUserToolProjects called");
        return ajaxCall.get(`${PAGE_ENDPOINT}/projects`).catch(handleErrorByMessage());
    },
    createNewProject(body: { sectionId: number; tool: string; projectName: string; lang: string }) {
        logger.trace("createNewProject called");
        return ajaxCall.post(`${PAGE_ENDPOINT}/projects`, body).catch(handleErrorByMessage());
    },
};
